<template>
  <div>
    <v-divider style="color: black"></v-divider>
    <MotherBanner v-if="promotionBanner" />
    <HomeBanner v-else />
    <div class="container-main">
      <div>
        <div class="mdn-Row mt-5">
          <div class="mdn-TabSelect w-100">
            <div
              class="mdn-Swiper mdn-Steps-swiper mobile-detect"
              data-mdn-slider-per-view="auto"
              data-mdn-slider-per-view-tablet="auto"
              data-mdn-slider-per-view-mobile="auto"
              data-mdn-auto-play="false"
            >
              <ul class="mdn-TabSelect-list mdn-Swiper-wrapper">
                <li
                  v-on:click="
                    (week = false),
                      (month = true),
                      (day = false),
                      onTag('mensal')
                  "
                  class="mdn-TabSelect-item mdn-Swiper-slide"
                  :class="[month ? 'mdn-TabSelect-active' : '']"
                >
                  <h2 class="mdn-TabSelect-anchor" data-mdn-href="#tab-1">
                    Nossas Ofertas
                  </h2>
                </li>
                <li
                  v-if="week"
                  v-on:click="
                    (week = true),
                      (month = false),
                      (day = false),
                      onTag('semanal')
                  "
                  class="mdn-TabSelect-item mdn-Swiper-slide"
                  :class="[week ? 'mdn-TabSelect-active' : '']"
                >
                  <div class="mdn-TabSelect-anchor" data-mdn-href="#tab-1">
                    Semanal
                  </div>
                </li>
                <li
                  v-if="day"
                  v-on:click="
                    (week = false),
                      (month = false),
                      (day = true),
                      onTag('diario')
                  "
                  class="mdn-TabSelect-item mdn-Swiper-slide"
                  :class="[day ? 'mdn-TabSelect-active' : '']"
                >
                  <div class="mdn-TabSelect-anchor" data-mdn-href="#tab-1">
                    Diario
                  </div>
                </li>
              </ul>
            </div>
            <div id="main-content" class="mdn-TabSelect-content">
              <div id="tab-1" class="mdn-TabSelect-panel mdn-TabSelect-active">
                <CarouselHome />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-10">
        <Swiper :valor-bonus="getBonusValue"></Swiper>
      </div>

      <Dialog
        :show-modal="smsErrorMessage === 'true'"
        :title="`${$t('modalMessages.home.title')} ${internet}`"
        :description="String($t('modalMessages.home.description'))"
        is-dialog-type="warning"
        @isClose="closeModalSms(internet)"
        @buttonConfirmation="closeModalSms(internet)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ActionMethod } from "vuex";
import { Action, Getter } from "vuex-class";
import BaseButton from "@/components/widgets/BaseButton.vue";
import HomeBanner from "@/components/banners/HomeBanner.vue";
import CarouselHome from "@/components/Swiper/CarouselHome.vue";
import Swiper from "@/components/core/Swiper.vue";
import Dialog from "@/components/common/Dialog/index.vue";
import { setClaroId } from "@/helpers/UtmModule.";
import { pushTagEvent } from "@/helpers/Gtm/gaExecuteEvents";
import { EVENT_NAME } from "@/helpers/Gtm/events";
import MotherBanner from "@/components/banners/MotherBanner.vue";

@Component({
  name: "HomeComponent",
  components: {
    MotherBanner,
    HomeBanner,
    BaseButton,
    Swiper,
    Dialog,
    CarouselHome,
  },
})
export default class HomeComponent extends Vue {
  @Getter getBonusValue!: string;
  @Action getAllPlans!: ActionMethod;
  @Action checkCupom!: ActionMethod;
  @Action setWebView!: ActionMethod;
  @Action setIsShowSimDelivery!: ActionMethod;
  @Action setResetCustomer!: ActionMethod;
  plans = new Array<any>();
  monthPlansToShow = new Array<any>();
  week = false;
  day = false;
  month = true;
  monthPlansToShowMobile = new Array<any>();
  showAlertMessage = false;
  internet = "";
  discounts = "";
  smsErrorMessage = "false";
  firstAccessRetry = "false";
  cupomSelected = "";
  cupomType = "";
  isWebview = false;
  promotionBanner = process.env.VUE_APP_MOTHER_DAY_BONUS === "true";

  onTag(props: any) {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:aba",
        eventLabel: `${props}`,
      });
    }
  }

  mounted() {
    this.setResetCustomer();
  }

  async created() {
    setClaroId(this.$route.query);
    pushTagEvent({
      eventName: EVENT_NAME.PAGE_VIEW_HOME,
    });
    this.smsErrorMessage = this.$route.params.smsErrorMensage;
    this.firstAccessRetry = this.$route.params.firstAccess;
    this.$gtm.trackView(this.$route.name!, this.$route.path);
  }

  move(from: number, to: number): void {
    const element = this.monthPlansToShow[from];
    this.monthPlansToShow.splice(from, 1);
    this.monthPlansToShow.splice(to, 0, element);
    this.monthPlansToShowMobile = this.monthPlansToShow;
  }

  getLabelName(plan: any): string {
    return plan.tag;
  }

  closeModalSms(internet: any): void {
    const win = window as any;

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "ok-entendi:".concat(internet),
      });
    }

    this.smsErrorMessage = "false";
    this.showAlertMessage = false;
  }
}
</script>

<style lang="scss">
.mobile-detect {
  display: none;
}
@media (min-width: 768px) {
  .mobile-detect {
    display: block;
  }
}
</style>
